import T from 'i18n-react';
import moment from 'moment/moment';
import convertNumberFromZenkakuToHankaku from './functions/convertNumberFromZenkakuToHankaku';
import formatTimeText from './functions/formatTimeText';

export const ONE_DAY = 2401;

export const workingTimeMinutes = Array(16)
  .fill(0)
  .map((v, i) => i * 30 + 30);

export const translateMinutes = (workingMinutes: number) => {
  const hours = Math.trunc(workingMinutes / 60);
  const minutes = workingMinutes - 60 * hours;

  if (hours > 0 && minutes > 0) {
    return T.translate('account.workingTime', {
      hours,
      minutes,
    });
  }

  if (hours > 0) {
    return T.translate('account.workingHours', {
      hours,
    });
  }

  return T.translate('account.workingMinutes', {
    minutes,
  });
};

export const convertValue = (value: string, prevState: string | undefined) => {
  if (value === '') return value;
  // １０ -> 10
  const convertValue = convertNumberFromZenkakuToHankaku(value);
  // 数字と「:」以外は受け付けない
  if (!convertValue.match(/^[0-9:]*$/)) return prevState;

  const timeText = formatTimeText(convertValue);
  // 時間は最大で 5 文字（「10:00」「6:00」）
  if (timeText.length > 5) return prevState;
  return timeText;
};

export const convertTimeText = (time: string, is_end_time: boolean) => {
  const convertTime = moment(time).isValid()
    ? moment(time).format('HH:mm')
    : time;
  if (is_end_time && convertTime === '00:00') return '24:00';
  return convertTime;
};

export const convertHourText = (time: string) => {
  const convertHour = moment(time, 'HH:mm').isValid()
    ? moment(time, 'HH:mm')
        .format('HH時間mm分')
        .replace(/00分|00時間/g, '')
        .replace(/^0/, '')
    : time;
  return convertHour;
};
